.table-head-cell {
  border-bottom: 0.1rem solid var(--color-grayscale-tuna);
  white-space: nowrap;

  padding-inline-start: 1.6rem;
}

.table-cell {
  padding-inline-start: 1.6rem;
}
